import React from 'react';
import { NavLink } from 'react-router-dom';
import { ShoppingCart, ClipboardList, UserCircle, BarChart3, Users } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
export function BottomNav() {
  const {
    user
  } = useAuth();
  // Only show for employees
  if (user?.role !== 'employee') return null;
  const navItems = [{
    path: '/employee/order',
    label: 'Pedir',
    icon: ShoppingCart
  }, {
    path: '/employee/my-orders',
    label: 'Mis Pedidos',
    icon: ClipboardList
  },
  // Manager-only tabs
  ...(user?.permissions?.isManager ? [{
    path: '/employee/company-report',
    label: 'Consumos',
    icon: BarChart3
  }, {
    path: '/employee/employees',
    label: 'Empleados',
    icon: Users
  }] : []), {
    path: '/employee/profile',
    label: 'Perfil',
    icon: UserCircle
  }];
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] h-16 z-30 pb-safe" data-id="element-133">
      <div className="flex items-center justify-around h-full" data-id="element-134">
        {navItems.map(item => {
        const Icon = item.icon;
        return <NavLink key={item.path} to={item.path} className={({
          isActive
        }) => `flex flex-col items-center justify-center w-full h-full gap-1 transition-colors relative ${isActive ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-135">
              {({
            isActive
          }) => <>
                  {isActive && <span className="absolute top-2 w-1 h-1 bg-gray-900 rounded-full" data-id="element-136" />}
                  <Icon size={20} strokeWidth={isActive ? 2.5 : 2} className={isActive ? 'mt-1' : ''} data-id="element-137" />
                  <span className="text-[10px] font-medium" data-id="element-138">{item.label}</span>
                </>}
            </NavLink>;
      })}
      </div>
    </nav>;
}